interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <div className="flex items-center justify-center gap-1.5 mt-10 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="px-3 h-9 flex items-center justify-center rounded-md border border-background-300/60 text-sm text-foreground-700 hover:border-accent-500/60 hover:text-accent-400 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? 'bg-accent-500 text-background-50 font-semibold'
              : 'border border-background-300/60 text-foreground-700 hover:border-accent-500/60 hover:text-accent-400'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="px-3 h-9 flex items-center justify-center rounded-md border border-background-300/60 text-sm text-foreground-700 hover:border-accent-500/60 hover:text-accent-400 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}